export default __webpack_public_path__ + "static/media/publicacion1.f68e03bb.jpg";